import { render, staticRenderFns } from "./BarcazaIndex.vue?vue&type=template&id=18711294"
import script from "./BarcazaIndex.vue?vue&type=script&lang=js"
export * from "./BarcazaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports